import { useRef, useEffect, useState } from 'react';
import {
  deletedDuplicateByAuthor,
  // preloadImg,
} from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';
import { v4 as uuidv4 } from 'uuid';
import useLocalStorage from './useLocalStorage';

export const useCarousel = (currentState) => {
  const { user, carousel, repeatCount, startFrom, speedFast, speedSlow } =
    useGetParams();
  // const [currentState, setCurrentState] = useState(null);
  const [isVisible, setIsVisible] = useState(null);
  const [showedMessages, setShowedMessages] = useState([]);

  const lastMessageIdRef = useRef(0);
  const nextMessageIndexRef = useRef(-1);
  const messagesRef = useRef([]);
  const currentMessageRef = useRef(null);
  const winnerMessageRef = useRef(null);

  const [winIds, setWinIds] = useLocalStorage('winIds', []);

  // время затраченное на появления одного сообщения в ms
  const [speed, setSpeed] = useState(500);

  const iactiveIdRef = useRef('');
  const prizeStateRef = useRef('');

  const protocol = window.location.protocol;

  const getBroadcastInfo = async () => {
    try {
      const response = await fetch(
        `${protocol}//api.stream.iactive.pro/titreInfo?user=${user}&from=${lastMessageIdRef.current}&type=1`,
        { cache: 'no-store' },
      );
      const data = await response.json();
      if (!data) return;
      let { messagesList, deletedMessagesIdList, visibility, iactiveId } = data;

      // При запуске следующей трансляции обновление

      if (iactiveIdRef.current !== iactiveId) {
        lastMessageIdRef.current = 0;
        nextMessageIndexRef.current = -1;
        setShowedMessages([]);
        messagesRef.current = [];
        iactiveIdRef.current = iactiveId;
      }

      // Определяем видимость титра

      if (!visibility && visibility !== isVisible) {
        setIsVisible(false);
        return;
      } else if (visibility && visibility !== isVisible) {
        setIsVisible(true);
      }

      // Удаляем сообщения по команде пользователя
      if (
        showedMessages.some((item) =>
          deletedMessagesIdList.includes(Number(item.id)),
        )
      ) {
        setShowedMessages(
          showedMessages.filter(
            (item) => !deletedMessagesIdList.includes(Number(item.id)),
          ),
        );
      }
      // если список сообщений не пустой

      if (Array.isArray(messagesList) && messagesList.length === 0) {
        // если имеются в списке сообщений удаленные
        if (
          messagesRef.current.some((el) =>
            deletedMessagesIdList.includes(+el.id),
          )
        ) {
          const newState = messagesRef.current.filter(
            (el) => !deletedMessagesIdList.includes(+el.id),
          );

          for (let i = 0; i < messagesRef.current.length; i++) {
            if (
              !newState.find(
                (el) =>
                  nextMessageIndexRef.current &&
                  el.id ===
                    messagesRef.current[nextMessageIndexRef.current]?.id,
              )
            ) {
              if (
                messagesRef.current[nextMessageIndexRef.current] ===
                messagesRef.current[messagesRef.current.length - 1]
              ) {
                nextMessageIndexRef.current--;
                if (nextMessageIndexRef.current < 0)
                  nextMessageIndexRef.current = 0;
              }
            }
            if (
              i < nextMessageIndexRef.current &&
              !newState.find((el) => el.id === messagesRef.current[i].id)
            ) {
              nextMessageIndexRef.current--;
              if (nextMessageIndexRef.current < 0)
                nextMessageIndexRef.current = 0;
            }
          }
          messagesRef.current = newState;
        }
        return;
      }

      // Удаляем сообщения, если они не содержат текста или картинки.
      messagesList = messagesList.filter(
        (el) =>
          !(
            Array.isArray(el.message.attachments) &&
            el.message.attachments.length > 0 &&
            typeof el.message.attachments[0] === 'object' &&
            el.message.attachments[0].type === 'audio_msg' &&
            el.message.content === ''
          ),
      );

      // const messagesRepeatCount = lastMessageIdRef.current === "0" ? repeatCount : null;

      //запоминаем id последнего сообщения, для дальнейших запросов
      lastMessageIdRef.current =
        messagesList[0]?.id || lastMessageIdRef.current;

      const result = [...messagesRef.current, ...messagesList.reverse()];

      messagesRef.current = deletedDuplicateByAuthor(
        result,
        nextMessageIndexRef,
      )
        .filter(
          (msg) => !winIds.map((el) => el.message.id).includes(msg.message.id),
        ) // победа 1 раз
        .slice(-repeatCount);

      // messagesRef.current = result;
    } catch (error) {
      console.error(error);
    }
  };

  const iterateIndex = (array) => {
    if (carousel === '1') {
      if (!array.length) {
        nextMessageIndexRef.current = -1;
        return;
      }
      if (nextMessageIndexRef.current < array.length - 1) {
        nextMessageIndexRef.current++;
      } else {
        if (messagesRef.current.length >= startFrom) {
          messagesRef.current = messagesRef.current.slice(-repeatCount);

          nextMessageIndexRef.current = 0;
        }
      }
    } else {
      if (nextMessageIndexRef.current < messagesRef.current.length - 1)
        nextMessageIndexRef.current++;
      else {
        nextMessageIndexRef.current = messagesRef.current.length - 1;
      }
    }
  };

  const updateShowedMessages = (newMessages) => {
    if (newMessages && messagesRef.current.length >= startFrom) {
      currentMessageRef.current = newMessages;
      const currentMessageWithUUID = { ...newMessages, UUID: uuidv4() };

      const newMessagesArr = [currentMessageWithUUID, ...showedMessages].slice(
        0,
        5,
      );
      winnerMessageRef.current = newMessagesArr[2];
      setShowedMessages(newMessagesArr);
    }
  };

  useEffect(() => {
    getBroadcastInfo().then(() => {
      if (messagesRef.current && messagesRef.current.length > 0) {
        iterateIndex(messagesRef.current);
        updateShowedMessages(messagesRef.current[nextMessageIndexRef.current]);
      }
    });
  }, []);

  // Выбор сообщения для показа
  useInterval(
    () => {
      iterateIndex(messagesRef.current);
      if (
        !messagesRef.current[nextMessageIndexRef.current]?.id ||
        (showedMessages.some(
          (el) => el.id === messagesRef.current[nextMessageIndexRef.current].id,
        ) &&
          carousel === '0')
      ) {
        return;
      } else if (carousel === '1' && messagesRef.current.length < startFrom) {
        return;
      } else {
        updateShowedMessages(messagesRef.current[nextMessageIndexRef.current]);
      }
    },
    currentState === 'S2' || currentState === 'S3' ? speed : null,
  );

  // Получение информации о титре
  useInterval(getBroadcastInfo, 1000);

  useEffect(() => {
    const curState = currentState;

    if (curState === 'S2' && speed !== speedSlow) {
      setSpeed(speedSlow);
    } else if (curState === 'S3' && speed !== speedFast) {
      setSpeed(speedFast);
    }

    if (['S4'].includes(curState)) {
      if (winnerMessageRef.current) {
        setWinIds([
          ...winIds,
          {
            state: prizeStateRef.current,
            message: { id: winnerMessageRef.current.message.id },
            author: winnerMessageRef.current.message.author,
          },
        ]);
        messagesRef.current = messagesRef.current.filter(
          (msg) =>
            !winIds.map((el) => el.message.id).includes(msg.message.id) &&
            msg.id !== winnerMessageRef.current.id,
        );
      }
    }

    if (curState === 'S5') {
      setWinIds([]);
      lastMessageIdRef.current = 0;
    }

    let numberState = currentState && Number(currentState.slice(1));

    // 5 - кол-во известных стадий S1-S5
    if (numberState > 5) {
      prizeStateRef.current = curState;

      let isDeletedMessage = showedMessages?.find((item) =>
        winIds.map((el) => el.message?.id).includes(item.message?.id),
      );

      if (isDeletedMessage) {
        setSpeed(500);

        setTimeout(() => {
          setShowedMessages(
            showedMessages.filter(
              (item) =>
                !winIds.map((el) => el.message.id).includes(item.message.id),
            ),
          );
        }, 100);
      }
    }
  }, [currentState]);

  return {
    currentState,
    isVisible,
    showedMessages,
    messagesRef: messagesRef.current,
    winnerMessage: winnerMessageRef.current,
    speed,
    winIds,
  };
};
